<template>
  <div class="question-list-wrap">
  	<y-teacher-info></y-teacher-info>
  	<y-nav></y-nav>
    <div class="content_detail">
    	<div v-if="isTeacher || price >= 0" class="question_wrap main">
        <!-- 老师身份 -->
    		<div v-if="isTeacher" class="action_wrap">
    			<p class="tishi left">提问将在提问时间的隔日24点过期，届时未回答提问的G币将自动退回用户账户</p>
    			<p v-if="price === -1" class="action right">您当前暂未开通问答功能，请点击右侧设置按钮开通<button type="button" @click="handleSetPrice">设置</button></p>
          <p v-else class="action right">您当前设置的问答价格为：<span>{{ price }}</span>G币/次 <button type="button" @click="handleSetPrice">修改</button></p>
    		</div>
        <!-- 其他身份 -->
        <div v-else class="action_wrap">
          <p class="tishi left">老师累计已回答<span>{{ teacherInfo.questionAnswerTotal }}</span>个提问</p>
          <p class="action right">老师当前设置的问答价格为：<span>{{ price }}</span>G币/次 <button type="button" @click="handleAsk(teacherInfo)">向TA提问</button></p>
        </div>
    		<div v-if="!isTeacher" class="user_nav">
    			<nuxt-link :to="{ query: {t: undefined} }" class="link" :class="{ spanred: !$route.query.t }">老师已回答的</nuxt-link>
          <nuxt-link :to="{ query: {t: 1} }" class="link" :class="{ spanred: $route.query.t*1 === 1 }">我的</nuxt-link>
    			<nuxt-link class="more" :to="`${authUser ? '/user' : ''}/question`">{{ authUser ? '查看我的所有提问 >>' : '查看所有提问 >>' }}</nuxt-link>
    		</div>
    		<div class="item_wrap">
    			<y-item v-for="item in list" :data="item" :is-my="$route.query.t*1 === 1 || isTeacher" :key="item.id"></y-item>
          <!--分页-->
          <y-pager :total="total" />
    		</div>
    	</div>
    	<div v-else class="question_wrap"><h1 class="tip">老师暂未开通问答功能</h1></div>
    </div>
  </div>
</template>

<script>
import Dialog from '@/utils/Dialog'
import YTeacherInfo from '@/components/TeacherInfo'
import YNav from '@/components/Nav'
import YItem from '@/components/question/Item'

export default {
  name: 'question-list',
  scrollToTop: true,
  watchQuery: ['page', 'num', 't'],
  validate ({ params }) {
    return params.id > 0
  },
  async asyncData ({ params, query, store, error, $axios }) {
    // 初始化老师数据
    let teacherInfo = await store.dispatch('teacher/getInfo', params.id)
    if (teacherInfo.error === 5) {
      error({ statusCode: 404, message: '该页面不存在' })
      return
    }
    let apiUrl
    let apiParams = {
      page: query.page || 1,
      num: query.num || process.env.DEFAULT_PAGE_SIZE,
      type: query.t
    }
    if (query.t || store.getters['teacher/isTeacher']) {
      apiUrl = 'Ask/MyList'
    } else {
      apiUrl = 'Ask/List'
      apiParams.teacher = params.id
    }

    let data
    if (!(query.t && !store.state.user.data)) {
      data = await $axios._get(apiUrl, apiParams)
    }
    // console.log(apiUrl, apiParams)
    return {
      list: data ? data.list : [],
      total: data ? data.totalCount : 0,
      teacherInfo,
      price: teacherInfo ? teacherInfo.questionPrice : 0
    }
  },
  head () {
    return {
      title: '问答-一富财经—打造中国最靠谱的的投资者教育平台,股市直播,股票交流'
    }
  },
	methods: {
    // 设置/修改提问价格
    handleSetPrice () {
      if (!this.$isLogin()) {
        Dialog.login()
        return
      }
      Dialog.prompt('请输入您想设置的价格：', '设置价格', {
        inputPattern: /^\d+$/,                 // 设置输入值必须匹配为数字
        inputPlaceholder: '输入值必须为数字',  // 输入框placeholder
        inputErrorMessage: '不合法的输入值'   // 警告信息
      }).then(({ value }) => {
        let params = {
          price: parseInt(value)
        }
        this.$axios._post('/Teacher/QuestionPrice', params).then(res => {
          this.price = params.price
          this.$notify({
            title: '成功',
            message: '价格修改成功',
            type: 'success'
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    handleAsk (type) {
      if(!this.$isLogin()){
        Dialog.login()
        return
      }
      Dialog.ask(type)
    }
	},
	computed:{
    isTeacher () {
      // 当前用户是否是当前查阅的老师
      return this.$store.getters['teacher/isTeacher']
    },
		authUser () {
      return this.$store.state.user.data
    }
  },
  watch: {
    '$route.query.t': {
      handler: function (val) {
        if (val && !this.$isLogin()) {
          Dialog.login()
        }
      },
      immediate: true
    }
  },
  components: {
  	YTeacherInfo,
		YNav,
    YItem
  }
}
</script>
